var Newsletter = function () {

    var $form;

    function init () {
        $form = $('form.mailchimp').first();
        if ($form.length > 0) {
            $form.submit(function(event){
                event.preventDefault();
                ajaxSendForm($form);
            });
            $('input.email',$form).on('keyup keypress blur change',function() {
                $form.toggleClass('empty', $(this).val() === '');
            });
        }
    }

    function ajaxSendForm() {
        $form.addClass('loading');
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            error: function () {
                alert('Could not connect to the registration server. Please try again later.')
            },
            success: function (data) {
                $form.removeClass('loading error success');
                if (data.result === 'success') {
                    $form.addClass('success');
                    $('.message',$form).html('Thank you for subscribing.');
                    $('.email',$form).val('');
                } else {
                    $form.addClass('error');
                    $('.message',$form).html(data.msg.substring(4));
                }
            }
        })
    }

    return {
        init: init
    }
}();
